var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplianceTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7336 3.65983C46.8996 1.42542 44.1163 0 41 0H10C4.47715 0 0 4.47715 0 10V41C0 46.5228 4.47715 51 10 51H41C46.5228 51 51 46.5228 51 41V22.6066L48 25.6066V41C48 44.866 44.866 48 41 48H10C6.13401 48 3 44.866 3 41V10C3 6.13401 6.13401 3 10 3H41C43.2883 3 45.3202 4.09802 46.5975 5.79594L48.7336 3.65983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.7377L24.1951 37L48 13",
    stroke: "#D42E79",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceTrue);
export default __webpack_public_path__ + "static/media/complianceTrue.044888382c9eb30e54f9ae33532fb255.svg";
export { ForwardRef as ReactComponent };